module.exports = __webpack_public_path__ + "static/media/iland.1f1de411.svg";